function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M50.4551 1.25C50.4551 0.559644 50.9184 0 51.49 0H62.8747C63.4463 0 63.9096 0.559644 63.9096 1.25V3.75C63.9096 4.44036 63.4463 5 62.8747 5H51.49C50.9184 5 50.4551 4.44036 50.4551 3.75V1.25Z",
  fill: "#625E70"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M33.6357 1.25C33.6357 0.559644 34.0991 0 34.6707 0H46.0553C46.6269 0 47.0903 0.559644 47.0903 1.25V3.75C47.0903 4.44036 46.6269 5 46.0553 5H34.6707C34.0991 5 33.6357 4.44036 33.6357 3.75V1.25Z",
  fill: "#625E70"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.8184 1.25C16.8184 0.559644 17.2817 0 17.8533 0H29.2379C29.8095 0 30.2729 0.559644 30.2729 1.25V3.75C30.2729 4.44036 29.8095 5 29.2379 5H17.8533C17.2817 5 16.8184 4.44036 16.8184 3.75V1.25Z",
  fill: "#625E70"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M0 1.25C0 0.559644 0.46337 0 1.03497 0H12.4196C12.9912 0 13.4545 0.559644 13.4545 1.25V3.75C13.4545 4.44036 12.9912 5 12.4196 5H1.03496C0.46337 5 0 4.44036 0 3.75V1.25Z",
  fill: "#625E70"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 12.3529C0 11.0534 0.613536 10 1.37037 10H20.5556C21.3124 10 21.9259 11.0534 21.9259 12.3529V19.4118C21.9259 20.7113 21.3124 21.7647 20.5556 21.7647H1.37037C0.613536 21.7647 0 20.7113 0 19.4118V12.3529ZM25.3519 12.3529C25.3519 11.0534 25.9654 10 26.7222 10H45.9074C46.6642 10 47.2778 11.0534 47.2778 12.3529V19.4118C47.2778 20.7113 46.6642 21.7647 45.9074 21.7647H26.7222C25.9654 21.7647 25.3519 20.7113 25.3519 19.4118V12.3529ZM1.37037 26.4706C0.613536 26.4706 0 27.524 0 28.8235V47.6471C0 48.9466 0.613535 50 1.37037 50H45.9074C46.6642 50 47.2778 48.9466 47.2778 47.6471V28.8235C47.2778 27.524 46.6642 26.4706 45.9074 26.4706H1.37037ZM50.0185 12.3529C50.0185 11.0534 50.6321 10 51.3889 10H72.6296C73.3865 10 74 11.0534 74 12.3529V28.8235C74 30.123 73.3865 31.1765 72.6296 31.1765H51.3889C50.6321 31.1765 50.0185 30.123 50.0185 28.8235V12.3529ZM51.3889 35.8824C50.6321 35.8824 50.0185 36.9358 50.0185 38.2353V47.6471C50.0185 48.9466 50.6321 50 51.3889 50H72.6296C73.3865 50 74 48.9466 74 47.6471V38.2353C74 36.9358 73.3865 35.8824 72.6296 35.8824H51.3889Z",
  fill: "#3C3A42"
});

function SvgIconLayoutHorizontal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 50,
    viewBox: "0 0 74 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLayoutHorizontal);
export default __webpack_public_path__ + "static/media/icon-layout-horizontal.c478b01b.svg";
export { ForwardRef as ReactComponent };